import {
    getOrganizationList,select
} from '@/api/sys.dataquery'

export default {
    namespaced: true,
    actions: {
        /**
         * 分页查询
         */
        getdataqueryList({
                             dispatch
                         }, {
                             vm,
                             pageable
                         }) {
            return getOrganizationList(pageable)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        /**
         * 分页查询
         */
        select({
                   dispatch
               }, {
                   vm,
                   pageable1
               }) {
            return select(pageable1)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        }
    }
}